import { fromJS } from 'immutable';
import {
  REQUEST_SET_EXPERTISE_VICTIM,
  REQUEST_SET_MISSION_POSTPONE,
  REQUEST_SET_MISSION_POSTPONE_EXPERTISE,
  RESET_STORE_DETAILS_EXPERTISE,
} from 'containers/ExpertExpertise/constants';

const initialState: any = fromJS({
  expertiseVictim: {},
  missionPostPone: [],
  missionPostPoneExpertise: [],
});

const ExpertExpertiseReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case REQUEST_SET_EXPERTISE_VICTIM:
      return state.set('expertiseVictim', fromJS(action.payload));
    case REQUEST_SET_MISSION_POSTPONE:
      return state.set('missionPostPone', fromJS(action.payload));
    case REQUEST_SET_MISSION_POSTPONE_EXPERTISE:
      return state.set('missionPostPoneExpertise', fromJS(action.payload));
    case RESET_STORE_DETAILS_EXPERTISE:
      return initialState;
    default:
      return state;
  }
};

export default ExpertExpertiseReducer;
